import { Injectable } from '@angular/core';
import { Timestamp } from 'firebase/firestore';

@Injectable({
  providedIn: 'root'
})
export class Funciones {

  MONTH_NAMES_ES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  constructor() { }

  convertirFecha(timestamp: Timestamp): string {
    if (!timestamp || typeof timestamp.toDate !== 'function') {
      return ''; // Return empty string or some default for invalid input
    }
    const dateObj: Date = timestamp.toDate();
    const year: number = dateObj.getFullYear();
    const month: string = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day: string = String(dateObj.getDate()).padStart(2, '0');

    return `${day}/${month}/${year}`;
  }

  convertirFechaHorasMinutos(timestamp: Timestamp): string {
    if (!timestamp || typeof timestamp.toDate !== 'function') {
      return '';
    }

    const dateObj: Date = timestamp.toDate();
    const year: number = dateObj.getFullYear();
    const month: string = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day: string = String(dateObj.getDate()).padStart(2, '0');

    const hours: string = String(dateObj.getHours()).padStart(2, '0');
    const minutes: string = String(dateObj.getMinutes()).padStart(2, '0');
    const seconds: string = String(dateObj.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  convertirFechaHorasMinutosAmPm(timestamp: Timestamp): string {
    if (!timestamp || typeof timestamp.toDate !== 'function') {
      return '';
    }

    const dateObj: Date = timestamp.toDate();

    // Obtener partes de la fecha
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();

    // Mes abreviado en español
    const month = dateObj.toLocaleString('es-ES', { month: 'short' });

    // Hora formateada en 12h sin segundos
    let hours = dateObj.getHours();
    const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'p.m.' : 'a.m.';

    hours = hours % 12;
    hours = hours === 0 ? 12 : hours;

    return `${day} ${month} ${year} a las ${hours}:${minutes} ${ampm}`;
  }

  dateToTimestamp(date: Date): Timestamp {
    return Timestamp.fromDate(date);
  }

  convertirFechaHoraMinutos(dateOrTimestamp: Timestamp | Date, hour: boolean): string {
    if (!dateOrTimestamp) {
      return '';
    }

    // Safely get a JavaScript Date object, whether the input is a Timestamp or a Date
    const dateObj: Date = (dateOrTimestamp as Timestamp).toDate ? (dateOrTimestamp as Timestamp).toDate() : (dateOrTimestamp as Date);

    const year: number = dateObj.getFullYear();
    const month: string = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day: string = String(dateObj.getDate()).padStart(2, '0');

    if (hour) {
      let hours: number = dateObj.getHours();
      const minutes: string = String(dateObj.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours === 0 ? 12 : hours; // 0 should be 12 AM
      return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
    } else {
      return `${day}/${month}/${year}`;
    }
  }

  // Nueva función para formatear moneda
  formatCurrency(value: number | string): string {
    const num = typeof value === 'string' ? parseFloat(value) : value;

    if (isNaN(num)) {
      return '0'; // o retornar '' si prefieres un string vacío
    }

    // Usar toLocaleString para formato con separadores
    // 'en-US' locale suele usar coma para miles y punto para decimales
    return num.toLocaleString('en-US');
  }

  private splitYM(ym: string) {
    const [year, month] = ym.split('-');
    return { year: parseInt(year, 10), month: parseInt(month, 10) };
  }

  formatYMtoText(ym: string) {
    const { year, month } = this.splitYM(ym);
    const monthName = this.MONTH_NAMES_ES[month - 1];
    return `${monthName}-${year}`;
  }
}
